"use strict";

exports.__esModule = true;
exports.wixVariable = exports.wixFont = exports.wixColor = void 0;
var _wixSiteThemeVariables = require("@wix/wix-site-theme-variables");
exports.CssColor = _wixSiteThemeVariables.CssColor;
exports.CssFont = _wixSiteThemeVariables.CssFont;
exports.CssVariable = _wixSiteThemeVariables.CssVariable;
const wixFont = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
exports.wixFont = wixFont;
const wixColor = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
exports.wixColor = wixColor;
const wixVariable = variable => {
  return {
    type: 'static',
    value: `var(--${variable})`
  };
};
exports.wixVariable = wixVariable;
//# sourceMappingURL=wixBrand.js.map